import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { usePageChrome } from '@/app/providers/PageChromeProvider'
import { applyModuleCtaVars } from '@/constants/module-cta'
import { resolveModuleFromPath } from '@/utils/module-theme'

/**
 * Pushes the active module's darker CTA gradient tokens onto `:root`
 * so `Button` default / `.btn-cta` follow the page theme.
 */
export function ModuleCtaStyleSync() {
  const { pathname } = useLocation()
  const { chrome } = usePageChrome()
  const moduleId = chrome.moduleId ?? resolveModuleFromPath(pathname)

  useLayoutEffect(() => {
    applyModuleCtaVars(document.documentElement, moduleId)
  }, [moduleId])

  return null
}
